import { ModularNav } from '@salecycle/ui-component-library';
import { usePermissions } from 'core/app/AppContext';
import React, { FC } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { TemplateManagementRoute } from 'sections/design/template-management/routes';
import routerHistory from 'store/history';
import useClientFromUrl from '../../utils/useClientFromUrl';
import MainNavLinks from './MainNavLinks';
import NavFooter from './ModularNavFooter';
import { SubNavLinks } from './SubNav/SubNavLinks';
import { BulkRetargetingRoutes } from 'sections/bulk-retargeting-campaigns/routes';

const renderFooter = () => {
  return <NavFooter />;
};

export const NewNav: FC = () => {
  const [heading, setHeading] = React.useState('');
  const { hasPermission } = usePermissions();

  const hasManageUserPermission = hasPermission('ManageUsers');
  const hasViewDashboardPermissions = hasPermission('ViewDashboards');

  const { clientLevel, clientId } = useClientFromUrl();

  const logoImageClicked = () => {
    routerHistory.push('/');
  };

  const isOnUserRoute = !!useRouteMatch({
    path: ['/user-management/users', '/user-management/roles', '/user-management/sftp-users'],
    exact: true,
  });
  const shouldHideUserSubNav = isOnUserRoute && !hasManageUserPermission;

  const hideNavBar = !!useRouteMatch({
    path: ['/sites/*/campaigns/onsite/*', BulkRetargetingRoutes.EDIT, TemplateManagementRoute.EDIT_COPY],
    exact: true,
  });

  const hideSubNav =
    !!useRouteMatch({
      path: [
        '*/create/*',
        '*/new-user/*',
        '/error',
        '/designs/asset-management',
        '/profile',
        '/groups/*/dashboard',
        '/groups/*/settings/settings',
        '/sites/*/campaigns/onsite/*',
        TemplateManagementRoute.EDIT,
        TemplateManagementRoute.EDIT_COPY,
        TemplateManagementRoute.EDIT_UNSUBSCRIBE,
        TemplateManagementRoute.EDIT_EMAIL_TRACKING_UNSUBSCRIBE,
        ...(hasViewDashboardPermissions ? [] : ['/', '/brands/*/dashboard', '/sites/*/dashboard']),
      ],
      exact: true,
    }) || shouldHideUserSubNav;

  return !hideNavBar ? (
    <nav>
      <ModularNav
        logoImageUrl="/images/new-msc-icon.png"
        imageAltText="SaleCycle Logo, Go to Home"
        onLogoClicked={logoImageClicked}
        hideSubNav={hideSubNav}
        subNavHeading={heading}
        mainNavContent={<MainNavLinks clientId={clientId} level={clientLevel} />}
        subNavContent={<SubNavLinks clientId={clientId} level={clientLevel} setHeading={setHeading} />}
        renderFooter={renderFooter}
      />
    </nav>
  ) : null;
};

export default NewNav;
